import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faUnlock } from '@fortawesome/pro-solid-svg-icons/faUnlock';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { SellerSettings } from '../../../enums/seller-settings/seller-settings';
import { getSellerSettingOptions } from '../../../services/settings/seller-settings-service';

import style from './style.module.less';

const productTypeOptions = getSellerSettingOptions(SellerSettings.useAdvancedProductDisplay);

const ProductsTab = ({ productType, setProductType, userHasAdminOrConfigRole }) => {
  const selectedProductType = productTypeOptions.find(({ value }) => value === productType);

  const permissionsIcon = (
    <FontAwesomeIcon className={classnames(style.icon, style['permissions-icon'])} icon={userHasAdminOrConfigRole ? faUnlock : faLock} />
  );

  return (
    <div className={style['tab-content']}>
      <div className={classnames(style.section, style['non-header-buffer'])}>
        <div className={style.settings}>
          <label>
            <FontAwesomeIcon className={style['key-icon']} icon={faUsers} />
            <FormattedMessage {...SellerSettings.useAdvancedProductDisplay.messageDescriptor} />
          </label>
          <div className={style['setting-options']}>
            <DropdownMenu
              className={style['product-type-dropdown']}
              disabled={!userHasAdminOrConfigRole}
              dropdownMenuShouldHaveWidthOfButton
            >
              <DropdownMenuToggler className={style['product-type-dropdown-selector']} theme='white'>
                <FormattedMessage {...selectedProductType.messageDescriptor} />
              </DropdownMenuToggler>
              {productTypeOptions.map((option) => (
                <DropdownMenuItem key={option.value} onClick={() => setProductType(option.value)} selected={productType.value === option}>
                  <FormattedMessage {...option.messageDescriptor} />
                </DropdownMenuItem>
              ))}
            </DropdownMenu>
            {permissionsIcon}
          </div>
        </div>
      </div>
    </div>
  );
};

ProductsTab.propTypes = {
  productType: PropTypes.bool.isRequired,
  setProductType: PropTypes.func.isRequired,
  userHasAdminOrConfigRole: PropTypes.bool.isRequired,
};

export default ProductsTab;
